import './profile.scss';
import { useAuth } from '../../contexts/auth';

const roleLabels = {
  admin: 'Administrador',
  tenant_admin: 'Administrador de empresas',
  operator: 'Operador',
};

export default function Profile() {
  const { user } = useAuth();
  const initials = user?.email?.slice(0, 2).toUpperCase() ?? 'PH';

  return (
    <div className="page-body profile-page">
      <div className="hub-page-header">
        <div><span className="hub-eyebrow">Segurança</span><h2>Minha conta</h2><p>Informações da sessão administrativa atual.</p></div>
      </div>
      <section className="profile-card">
        <div className="profile-avatar" aria-hidden="true">{initials}</div>
        <div className="profile-identity">
          <span>Usuário conectado</span>
          <strong>{user?.email ?? 'Sessão não identificada'}</strong>
          <span className="hub-status hub-status--positive">Sessão ativa</span>
        </div>
        <dl className="profile-details">
          <div><dt>Perfil</dt><dd>{user ? roleLabels[user.role] : '—'}</dd></div>
          <div><dt>Empresas autorizadas</dt><dd>{user?.role === 'admin' ? 'Todas' : (user?.companyIds.length ?? 0)}</dd></div>
          <div><dt>Permissões</dt><dd>{user?.scopes.length ? user.scopes.join(', ') : 'Somente consulta'}</dd></div>
        </dl>
      </section>
    </div>
  );
}
